'use strict';

const Alerts = require('lib/alerts');
var loader   = require('helpers/loader');
var EditView = require('./Edit.js');
var log      = require('lib/log')('form-view');

module.exports = EditView.extend({
    events: function() {
        var parentEvents = _.isFunction(EditView.prototype.events) ?
            EditView.prototype.events() : EditView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-save':    'save',
            'click .js-cancel':  'cancel',
            'click .js-destroy': 'destroy'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            actOnSave:          true,
            actOnCancel:        true,
            actOnDestroy:       true
        });
        this.options.templateExtra =
            _.defaults(this.options.templateExtra || {}, {
                forceDestroyButton: false
            });

        return EditView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        var r = EditView.prototype.bindHandlers.apply(this, arguments);

        app.events.on('navigate', function(status) {
            log.info('Caught navigate event...');
            if (this.dirty()) {
                log.info('...and we have unsaved changes');

                status.unsaved = true;
                status.msg = 'You have unsaved changes.  Exiting this ' +
                    'page will result in the changes being discarded.';
            } else {
                status.unsaved = false;
            }
        }, this);

        app.events.on('hard-exit', this.hardExit, this);

        return r;
    },

    unbindHandlers: function() {
        var r = EditView.prototype.unbindHandlers.apply(this, arguments);

        app.events.off(null, null, this);

        return r;
    },

    hardExit: function() {
        log.info('The user decided to abandon form. Syncing model and leaving');

        this.unbindHandlers();
        this.fetch();
    },

    render: function() {
        var returnValue = EditView.prototype.render.apply(this, arguments);

        this.markMandatoryFields();

        return returnValue;
    },

    enableDestroyButton: function() {
        this.options.templateExtra = _.extend(this.options.templateExtra, {
            forceDestroyButton: true
        });

        return this.render();
    },

    disableDestroyButton: function() {
        this.options.templateExtra = _.extend(this.options.templateExtra, {
            forceDestroyButton: false
        });

        return this.render();
    },

    dirty: function() {
        return this.model.isNew() ? this.tainted : this.model.dirty();
    },

    save: function(ev) {
        var $button = this.$(ev.currentTarget);
        var stopLoader = loader.startFullScreen($button);

        ev.preventDefault();

        if ($button.closest('.js-ext', this.el).length > 0) {
            stopLoader();
            return;
        }

        this.trigger('save', this.model);

        if (!this.model) {
            stopLoader();
            return;
        }

        if (this.constraints) {
            this.model.setAdditionalConstraints(this.constraints);
        }
        if (this.options.actOnSave !== true) {
            let errors = this.model.validate(this.model.attributes);

            if (!_.isEmpty(errors)) {
                log.error(errors);

                this.invalid(this.model, {errors});
                stopLoader();
                return;
            }

            this.trigger('saved', this.model);
            stopLoader();

            return;
        }

        return this.model.save(this.model.unsavedAttributes).then(() => {
            this.trigger('saved', this.model);
        }).catch(err => {
            log.error(err);

            if (_.isObject(err)) {
                return;
            }

            Alerts.show('criticalError', err);
        }).finally(() => {
            this.model.setAdditionalConstraints(null);
            stopLoader();
        });
    },

    fetch: function() {
        return this.model.fetch();
    },

    cancel: function(ev) {
        var $button = this.$(ev.currentTarget);
        var stopLoader;

        ev.preventDefault();

        if ($button.closest('.js-ext', this.el).length > 0) {
            return;
        }

        stopLoader = loader.startFullScreen($button);

        this.trigger('cancel', this.model);

        if (this.options.actOnCancel !== true) {
            this.trigger('cancelled', this.model);
            stopLoader();

            return;
        }

        return this.fetch()
            .then(() => {
                this.trigger('cancelled', this.model);
            })
            .catch(err => { Alerts.show('criticalError', err); })
            .finally(stopLoader);
    },

    destroy: function(ev) {
        var $button = this.$(ev.currentTarget);
        var stopLoader = loader.startFullScreen($button);

        ev.preventDefault();

        if ($button.closest('.js-ext', this.el).length > 0) {
            stopLoader();
            return;
        }

        this.trigger('destroy', this.model);

        if (this.options.actOnDestroy !== true) {
            this.trigger('destroyed', this.model);
            stopLoader();

            return;
        }

        this.model.destroy().then(() => {
            this.trigger('destroyed', this.model);
        })
        .catch(err => { Alerts.show('criticalError', err); })
        .finally(stopLoader);
    },

    markMandatoryFields: function(constraints) {
        const fields = constraints || (this.model && this.model.constraints());

        _(fields).each((item, key) => {
            let markAsMandatory = false;
            if (item.presence) {
                markAsMandatory = true;
            } else if (typeof item === 'function') {
                // Try to get whether is mandatory without failing
                let constraints = {};
                try {
                    const attr = this.model.attributes;
                    constraints = item(attr[item.name], attr);
                }
                catch (e) {
                    //
                }
                if (constraints && constraints.presence) {
                    markAsMandatory = true;
                }
            }

            if (markAsMandatory) {
                /* FIXME Form markup is a bit fucked up, which makes id'ing labels
                 * equally fucked up. So, first we need a better form markup and
                 * then we fix this
                 * */
                var $label = this.$('[name="' + key + '"]')
                    .closest('div:not(.input-group):not(.iradio_square-blue)')
                    .prev('.control-label');
                $label.find('.js-required').remove();
                $label.append(
                    '<span class="js-required js-required-' + key + '">' +
                        '*' +
                    '</span>'
                );
            }
        });
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/Form.js